import PaymentPageB2CSection from "../../components/NewDesign/Payment/PaymentPageB2CSection/PaymentPageB2CSection"
import PaymentOutlinePage from "../../components/PaymentOutlinePage"
import { useLocation } from "react-router-dom";

const PaymentB2CPage = (props) => {
    const location = useLocation();
    const { state } = location;
    console.log("state---b2cpage",state?.isMobile);
    let isMobile=false;
    if(state?.isMobile)
    {
    isMobile = state?.isMobile;
    }
    return (
        <PaymentOutlinePage isMobile={isMobile}>
            <PaymentPageB2CSection {...props} />
        </PaymentOutlinePage>
    )
}

export default PaymentB2CPage